import { SimplePaymentMethodCardRow } from "./SimplePaymentMethodCardRow";
import { ISimplePaymentMethodCard } from "./ISimplePaymentMethodCard";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { useState } from "react";
import { AbsoluteLoader } from "@common/Loader/AbsoluteLoader";
import { IError } from "itsf-ui-common";
import { Error } from "@common/HandleErrorAndLoading/Error";
import { Box } from "@mui/material";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IParams {
    simplePaymentMethodCardList: ISimplePaymentMethodCard[];
    isPaymentLoading: boolean;
    paymentError: IError | undefined;
    handlePay(selectedPaymentMethodCard: string): void;
}

export const SimplePaymentMethodCardList = (props: IParams) => {
    const { simplePaymentMethodCardList, isPaymentLoading, paymentError, handlePay } = props;

    const [selectedPaymentMethodCard, setSelectedPaymentMethodCard] = useState<string | undefined>(
        simplePaymentMethodCardList.length ? simplePaymentMethodCardList[0].providerReference : undefined
    );

    const { t } = useTranslation("summary");
    const { classes } = useStyle();

    return (
        <Box paddingX={5} paddingY={2}>
            {isPaymentLoading && <AbsoluteLoader size={40} />}
            {simplePaymentMethodCardList.map((paymentMethod, index) => (
                <SimplePaymentMethodCardRow
                    dataLength={simplePaymentMethodCardList.length}
                    index={index}
                    key={paymentMethod.providerReference}
                    paymentMethod={paymentMethod}
                    selectedPaymentMethodCard={selectedPaymentMethodCard}
                    setSelectedPaymentMethodCard={setSelectedPaymentMethodCard}
                />
            ))}
            {paymentError && (
                <Box paddingTop={4}>
                    <Error error={paymentError} />
                </Box>
            )}
            <LabeledButton
                className={classes.payNowButton}
                color="secondary"
                disabled={!selectedPaymentMethodCard || isPaymentLoading}
                labelText={t("payNow")}
                onClick={() => selectedPaymentMethodCard && handlePay(selectedPaymentMethodCard)}
            >
                {t("payNow")}
            </LabeledButton>
        </Box>
    );
};
